
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"foreground",attrs:{"d":"M120 65c0-16.545-16.82-30-37.5-30S45 48.455 45 65s16.82 30 37.5 30c3.865 0 7.725-.49 11.485-1.46l12.395 6.2c.36.175.74.26 1.12.26.615 0 1.22-.225 1.695-.66a2.51 2.51 0 00.625-2.77l-3.395-8.495C114.965 82.41 120 73.915 120 65z"}}),_c('path',{staticClass:"background",attrs:{"d":"M82.5 30v-.125c.23.085.48.14.73.155v.005h.05c.035.005.075 0 .1 0a2.5 2.5 0 002.5-2.5c0-.545-.17-1.045-.465-1.46C79.605 10.45 62.96 0 43.75 0 19.625 0 0 16.82 0 37.5c0 11.105 5.595 21.395 15.43 28.545L10.265 76.38a2.49 2.49 0 00.52 2.935 2.49 2.49 0 002.955.355l13.23-7.56c3.5 1.245 7.225 2.095 11.095 2.535.85.115 1.61-.215 2.15-.82.54-.61.75-1.44.57-2.23A28.93 28.93 0 0140 65c0-19.3 19.065-35 42.5-35z"}})])
          )
        }
      }
    